import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import Support from '../Profile/Support'

const SupportPage = () => {
  return (
    <>
        <Header/>
        <Support/>
        <Footer/>
    </>
  )
}

export default SupportPage